import { EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'
import { AIButton } from '../AIButton'
import {
  AIButtonIconGradientIdPrefix,
  AIButtonIconGradientSvgPlacement,
} from '../AIButton.constants'

import * as styles from './AIButtonContainedLight.module.css'

function AIButtonContainedLight({
  beforeIconProps: {
    height: beforeIconHeight = ICON_HEIGHT_20,
    ...beforeIconProps
  } = EMPTY_OBJECT,
  className = styles.aiButtonContainedLight,
  height = BUTTON_HEIGHT_32,
  textClassName = styles.label,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button.Contained}
      beforeIconProps={{ ...beforeIconProps, height: beforeIconHeight }}
      className={className}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.ContainedLight}
      gradientPlacement={AIButtonIconGradientSvgPlacement.Embedded}
      height={height}
      textClassName={textClassName}
    />
  )
}

export default AIButtonContainedLight
